import moment from 'moment'
import { useIntl } from 'react-intl'
import { placeNames } from '../../../../../helpers/globalVariables'
import {
  isAdmin,
  isDealer,
  isOperator,
} from '../../../../../services/AccountService'
import { getComp } from '../../../../../utils/utils/DI'

export const useEditData = (
  currentServiceData: any,
  serviceAddRequestFormStore: any,
  isEdit: boolean,
  isReportEdit: boolean
) => {
  const territoryStore = getComp('TerritoryStore')
  const { shownSenders, defaultSenders } = getComp('SendersStore')
  const categoriesStore = getComp('CategoriesStore')
  const intl = useIntl()

  const defaultSenderId =
    currentServiceData?.senderId ||
    findDefaultSenderInShownSenders(defaultSenders, shownSenders)

  const disabledCreatedStatus = () => {
    return (
      currentServiceData?.status === 1 ||
      currentServiceData?.status === 2 ||
      currentServiceData?.status === 4 ||
      currentServiceData?.status === 5 ||
      currentServiceData?.status === 7 ||
      currentServiceData?.status === 10
    )
  }

  let editData = [
    {
      propName: 'surname',
      validName: 'surname',
      label: intl.formatMessage({ id: 'Фамилия' }),
      type: 'text',
      capitalizeFirstLetter: true,
    },
    {
      propName: 'name',
      label: intl.formatMessage({ id: 'Имя' }),
      type: 'text',
      capitalizeFirstLetter: true,
    },
    {
      propName: 'patronymic',
      validName: 'patronymic',
      label: intl.formatMessage({ id: 'Отчество' }),
      type: 'text',
      capitalizeFirstLetter: true,
    },
    {
      propName: 'phoneNumber',
      validName: 'phoneNumber',
      mask: '+7 (999)-999-99-99',
      label: intl.formatMessage({ id: 'Телефон' }),
      type: 'text',
    },

    {
      propName: 'territory',
      validName: 'territory',
      label: intl.formatMessage({ id: 'Регион' }),
      items: territoryStore.collection,
      type: 'select',
    },
    {
      propName: 'district',
      validName: 'district',
      label: intl.formatMessage({ id: 'Округ' }),
      autocompleteOptions: {
        territory: serviceAddRequestFormStore.data['territory'],
        type: 'district',
      },
      readOnly: serviceAddRequestFormStore.data.territory === '',
      disabled: serviceAddRequestFormStore.data.territory === '',
      territorySelect: true,
      type: 'autocomplete',
    },
    {
      propName: 'locality',
      validName: 'locality',
      label: intl.formatMessage({ id: 'Населённый пункт' }),
      territorySelect: true,
      autocompleteOptions: {
        territory: serviceAddRequestFormStore.data['territory'],
        district: serviceAddRequestFormStore.data['district'],
        type: 'locality',
      },
      readOnly: serviceAddRequestFormStore.data.district === '',
      disabled: serviceAddRequestFormStore.data.district === '',
      type: 'autocomplete',
    },
    {
      propName: 'addressType',
      validName: 'addressType',
      label: intl.formatMessage({ id: 'Топоним (улица / переулок и т.д.)' }),
      type: 'autocomplete',
      items: placeNames,
    },
    {
      propName: 'address',
      validName: 'address',
      label: intl.formatMessage({
        id: 'Наименование топонима (улицы / переулка и т.д.)',
      }),
      type: 'text',
    },
    {
      propName: 'house',
      validName: 'house',
      label: intl.formatMessage({ id: 'Дом' }),
      type: 'text',
      paste: true,
      onlyNumbers: true,
    },
    {
      propName: 'building',
      validName: 'building',
      label: intl.formatMessage({ id: 'Корпус' }),
      type: 'text',
      paste: true,
      onlyNumbersAndLetters: true,
    },
    {
      propName: 'apartment',
      validName: 'apartment',
      label: intl.formatMessage({ id: 'Квартира' }),
      type: 'text',
      paste: true,
      onlyNumbers: true,
    },
    {
      propName: 'created',
      validName: 'created',
      label: intl.formatMessage({ id: 'Дата обращения' }),
      mask: '99-99-9999, 99:99',
      placeholder: 'DD-MM-YYYY, HH:mm',
      type: 'text',
      defaultValue: moment().format('DD-MM-YYYY, HH:mm'),
    },

    {
      propName: 'preferentialCategories',
      validName: 'preferentialCategories',
      label: intl.formatMessage({ id: 'Льготные категории' }),
      items: categoriesStore.collection.map((el: any) => {
        return { key: el.name, value: el.id }
      }),
      multiple: true,
      type: 'multiple',
      onClear: serviceAddRequestFormStore.onClearMultiple,
    },
    {
      propName: 'senderId',
      validName: 'senderId',
      label: intl.formatMessage({ id: 'Источник данных о заявке' }),
      items: shownSenders.map((el: any) => ({ key: el.name, value: el.id })),
      defaultValue: defaultSenderId,
      type: 'select',
    },
    {
      propName: 'additionalInfo',
      validName: 'additionalInfo',
      label: 'Дополнительная информация',
      type: 'text',
      multiline: true,
      rows: 5,
      paste: true,
    },
    {
      propName: 'serviceCenterComment',
      validName: 'serviceCenterComment',
      label: 'Комментарий для СЦ',
      type: 'text',
      multiline: true,
      rows: 5,
      paste: true,
    },
  ]

  if (isOperator() && isEdit) {
    const arr = ['additionalInfo', 'preferentialCategories', 'created']
    editData = editData.filter((el) => !arr.includes(el.propName))
  }

  if (isAdmin() && isEdit) {
    const arr = ['created']
    editData = editData.filter((el) => !arr.includes(el.propName))
  }

  if (isDealer()) {
    const arr = ['senderId', 'created']
    editData = editData.filter((el) => !arr.includes(el.propName))
  }

  if (isDealer() && isEdit && isReportEdit) {
    const arr = [
      'created',
      'territory',
      'preferentialCategories',
      'additionalInfo',
    ]
    editData = editData.filter((el) => !arr.includes(el.propName))
  }

  if (disabledCreatedStatus() && isEdit) {
    editData = editData.filter((el) => el.propName !== 'created')
  }

  return {
    editData,
    isLocationUpdated: () =>
      !locationEquals(currentServiceData, serviceAddRequestFormStore.data),
  }
}

// Вспомогательная функция для поиска отправителя по умолчанию
function findDefaultSenderInShownSenders(
  defaultSenderId: any,
  sendersList: any[]
): string | undefined {
  if (!defaultSenderId || !sendersList) return ''

  const foundSender = sendersList.find(
    (sender: any) => sender.id === defaultSenderId
  )

  return foundSender ? defaultSenderId : ''
}

function locationEquals(current: ILocation, formData: ILocation) {
  return !current
    ? true
    : current?.territory === formData.territory &&
        current?.district === formData.district &&
        current?.locality === formData.locality
}

interface ILocation {
  territory?: string | null
  district?: string | null
  locality?: string | null
}
